import { Component, model } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { FileService } from '../../services/file/file.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ERROR_SNACKBAR_CONFIG } from '../../constants';

@Component({
  selector: 'app-home',
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatGridListModule,
    MatIconModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  form!: FormGroup;
  loadingSpinnerActive = false;

  constructor(
    private fb: FormBuilder,
    private _router: Router,
    private _fileService: FileService,
    private _snackBar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      modelId: ['', Validators.required],
    });
  }

  onClickOpenModel() {
    this.loadingSpinnerActive = true;

    this._fileService.getExcelFileById(this.modelId).subscribe({
      next: (result) => {
        this.loadingSpinnerActive = false;

        if (!result) {
          return this._snackBar.open(
            'Le code saisi est incorrect. Veuillez réessayer.',
            'Fermer',
            ERROR_SNACKBAR_CONFIG,
          );
        }

        return this._router.navigate(['/model'], {
          queryParams: { id: this.modelId },
        });
      },
      error: () => {
        this.loadingSpinnerActive = false;

        return this._snackBar.open(
          "Une erreur s'est produite. Veuillez réessayer plus tard.",
        );
      },
    });
  }

  get modelId() {
    return this.form.get('modelId')!.value;
  }
}
